import { Controller } from "@hotwired/stimulus";

/**
 * Dispatches a custom event on window to toggle the notifications panel.
 * Used by bell buttons that are outside the notifications-panel controller's DOM tree.
 */
export default class extends Controller {
  dispatch() {
    window.dispatchEvent(new CustomEvent("notifications-panel:toggle"));
  }
}
